import $ from 'jquery';

const options = {
    'class': {
        onShow: 'is-shown'
    },
    'selector': '.js-outdated-browser'
};

function init(){
    const $elm = $(options.selector);

    $elm.addClass(options.class.onShow);

    $elm.on('click', '[data-close]', () => {
        $elm.removeClass(options.class.onShow);
    });
}

export default {
    init: init
};
